import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class LedgerService {
  async fetch(data) {
    const response = await ajaxService.post(`/ledger`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async sendMail(data) {
    const response = await ajaxService.post(`/ledger/send-mail`, data);
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const ledgerService = new LedgerService();

export default ledgerService;
